/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getStorage } from '../../../utils/functions/localstorage';
import api from '../../../utils/functions/api';
import {
  TextField,
  Grid,
  Button,
  Paper,
  Typography,
  Box,
  FormControl,
  Autocomplete,
  Select,
  MenuItem,
  Dialog,
  Snackbar,
  InputLabel,
  FormHelperText,
  Alert,
} from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PersonIcon from '@mui/icons-material/Person';
import InputAdornment from '@mui/material/InputAdornment';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import QrCodeIcon from '@mui/icons-material/QrCode';
import TollIcon from '@mui/icons-material/Toll';
import LinkIcon from '@mui/icons-material/Link';
import thailandFlag from '../../../assets/images/thai.avif';
import ukFlag from '../../../assets/images/uk.webp';
import Swal from 'sweetalert2';
import thai_qr_logo from '../../../assets/images/thai_qr_logo.png';
import creditcardLogo from '../../../assets/images/CreditCardImage1.png';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';

import QRCode from '../../../components/PayOptionE-Entry/QRCode';
import { max } from 'lodash';

import dayjs from 'dayjs';

function Donation() {
  const navigate = useNavigate();

  const [orderId, setOrderId] = useState('');
  const [key, setKey] = useState('');
  const [amount, setAmount] = useState('');
  const [name, setName] = useState('');
  const [merchant, setMerchant] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [clickedButton, setClickedButton] = useState(null);
  const [language, setLanguage] = useState('TH');

  const [maxAmount, setMaxAmount] = useState(1000000);
  const [minAmount, setMinAmount] = useState(1);

  const [qrCodeImage, setQrCodeImage] = useState('');
  const [paymentRefId, setPaymentRefId] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [qrPopupOpen, setQrPopupOpen] = useState(false);

  const handleCloseQrPopup = () => {
    setQrPopupOpen(false);
    // setSelectedOption('');
  };

  // เพิ่มที่ state
  const [orderIdError, setOrderIdError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [keyError, setKeyError] = useState(false);
  const [amountError, setAmountError] = useState(false);

  // ฟังก์ชันใหม่สำหรับเช็กก่อนกด
  const handleAttemptClick = (type) => {
    // if (!isFormValid) {
    //   setOrderIdError(orderId.trim() === '');
    //   setNameError(name.trim() === '');
    //   // setKeyError(key.trim() === '');
    //   setAmountError(amount.trim() === '');
    //   return;
    // }

    // setOrderIdError(false);
    // setNameError(false);
    // setKeyError(false);
    // setAmountError(false);
    handleButtonClick(type);
  };

  const isFormValid =
    orderId.trim() !== '' && amount.trim() !== '' && name.trim() !== '';

  const handleButtonClick = async (type) => {
    setClickedButton(type);

    const tokens = getStorage('token') || '';
    try {
      const { data } = await api.post(
        `${process.env.REACT_APP_APIHOST}/eentry/orderpayment/create`,
        {
          customer_name: 'E-Donationเพื่อพนักงานINETศูนย์หาดใหญ่',
          amount: amount,
          order_id: dayjs().format('YYYYMMDDHHmmss'),
          payment_type: type,
          key_cashier:
            'a6d9256fff013e6a4667f23e5945401bded628a88184a7cd3600b73f3e172f1ffd47a611136515cb5352b98061f3e70024c71784796',
        },
        { headers: { Authorization: tokens } },
      );

      if (type === 'QR') {
        navigate('/QrCodeEducation', {
          state: {
            qrCodeImage: data.payment_qr,
            paymentRefId: data.payment_ref_id,
            payment_token: data.payment_token,
          },
        });
      } else if (type === 'QRCS') {
        navigate('/QRCreit', {
          state: {
            qrCodeImage: data.payment_qr,
            paymentRefId: data.payment_ref_id,
            payment_token: data.payment_token,
          },
        });
      } else if (type === 'Cashier') {
        navigate('/LinkCashier', {
          state: {
            qrCodeImage: data.payment_qr,
            paymentRefId: data.payment_ref_id,
            payment_token: data.payment_token,
            payment_url: data.payment_url,
          },
        });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message;

      // เช็กข้อความซ้ำ
      if (errorMessage && errorMessage.includes('already exists')) {
        setOrderIdError(true); // ขึ้นกรอบแดง

        Swal.fire({
          icon: 'error',
          title: language === 'TH' ? 'เกิดข้อผิดพลาด' : 'Error',
          text:
            language === 'TH' ? 'หมายเลขคำสั่งซื้อซ้ำ' : 'Duplicate order ID',
          confirmButtonColor: '#d33',
          confirmButtonText: language === 'TH' ? 'ปิด' : 'Close',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: language === 'TH' ? 'เกิดข้อผิดพลาด' : 'Error',
          text:
            errorMessage ||
            (language === 'TH'
              ? 'ไม่สามารถสร้างรายการได้'
              : 'Unable to create payment'),
          confirmButtonColor: '#d33',
          confirmButtonText: language === 'TH' ? 'ปิด' : 'Close',
        });
      }
    }
  };

  const getMerchants = async () => {
    try {
      const token = getStorage('token');
      const { data } = await api.get(
        `${process.env.REACT_APP_APIHOST}/eentry/merchants`,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      const names = data.data.map(
        ({ id, name, key_cashier, paymentMethod }) => ({
          id,
          name,
          key_cashier,
          paymentMethod,
        }),
      );
      setMerchant(names);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getMerchants();
  }, []);

  const getLimitAmount = async () => {
    try {
      const token = getStorage('token');
      const res = await api.get(
        `${process.env.REACT_APP_APIHOST}/eentry/configs`,
        {
          headers: {
            Authorization: token,
          },
        },
      );

      // payload อาจอยู่ที่ res.data หรือ res.data.data ขึ้นกับ backend
      const payload = res.data;

      // หา array ที่แท้จริง (รองรับหลายชื่อฟิลด์)
      const arr = Array.isArray(payload)
        ? payload
        : Array.isArray(payload.data)
          ? payload.data
          : Array.isArray(payload.result)
            ? payload.result
            : [];

      if (!arr.length) {
        console.warn('eentry/configs response ไม่ใช่ array:', payload);
        return;
      }

      console.log('payload', payload);

      // แปลง array → object { KEY: value, ... }
      const config = arr.reduce((acc, item) => {
        if (item && item.key !== undefined) acc[item.key] = item.value;
        return acc;
      }, {});

      // ใช้ค่าได้เลย (ถ้าต้องการเป็นตัวเลข ให้แปลงด้วย Number/parseInt)
      // setMaxAmount(config.MAX_AMOUNT ?? null);
      // setMinAmount(config.MIN_AMOUNT ?? null);

      // ถ้าต้องการเก็บทั้ง object ก็เรียก setConfig (ถ้ามี)
      // if (typeof setConfig === 'function') setConfig(config);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getLimitAmount();
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh', // สูงเต็มจอจริง ๆ
        width: '100%', // กว้างเต็มจอ
        backgroundColor: '#007CC2', // สีเขียว
        display: 'flex', // ใช้ flex จัดกลาง
        justifyContent: 'center', // จัดกลางแนวนอน
        alignItems: 'center', // จัดกลางแนวตั้ง
        // p: 2, // กันชนเล็กน้อย
      }}
    >
      {/* Language Selector - Top Right */}
      {/* <Box
        sx={{
          position: 'absolute',
          top: 5,
          right: 14,
          zIndex: 1,
        }}
      >
        <FormControl variant="outlined" size="small">
          <Select
            value={language}
            onChange={handleLanguageChange}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src={selected === 'TH' ? thailandFlag : ukFlag}
                  alt={selected === 'TH' ? 'Thai Flag' : 'UK Flag'}
                  style={{
                    width: '15px',
                    height: '15px',
                    marginRight: '10px',
                  }}
                />
                {selected === 'TH' ? 'ไทย' : 'English'}
              </Box>
            )}
            sx={{
              fontSize: '12px',
              height: '25px',
              width: '110px',
            }}
          >
            <MenuItem value="TH">
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src={thailandFlag}
                  alt="Thai Flag"
                  style={{
                    width: '20px',
                    height: '20px',
                    marginRight: '10px',
                  }}
                />
                ไทย
              </Box>
            </MenuItem>
            <MenuItem value="EN">
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src={ukFlag}
                  alt="UK Flag"
                  style={{
                    width: '20px',
                    height: '20px',
                    marginRight: '10px',
                  }}
                />
                English
              </Box>
            </MenuItem>
          </Select>
        </FormControl>
      </Box> */}

      {/* Main Content */}
      <Grid
        container
        spacing={3}
        justifyContent="center"
        alignItems="center"
        sx={{ minHeight: '50vh' }}
      >
        <Grid item xs={12} sm={10} md={6} lg={4}>
          <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
            <Typography
              // variant="h5"
              gutterBottom
              textAlign="center"
              sx={{ color: 'black', fontWeight: 'bold', fontSize: '24px' }}
            >
              {language === 'TH'
                ? 'บริจาคเพื่อช่วยเหลือพนักงาน'
                : 'Create Payment'}
            </Typography>
            <Typography
              // variant="h5"
              gutterBottom
              textAlign="center"
              sx={{ color: 'black', fontWeight: 'bold', fontSize: '24px' }}
            >
              {language === 'TH'
                ? 'นางสาวสริญญา บุญชัยวัฒนา (โอ๋) จากเหตุการณ์ไฟไหม้ที่พักอาศัย'
                : 'Create Payment'}
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth required error={keyError}>
                  <Autocomplete
                    fullWidth
                    disabled
                    options={merchant}
                    getOptionLabel={(option) => option.name || ''}
                    isOptionEqualToValue={(option, value) =>
                      option.key_cashier === value.key_cashier
                    }
                    value={
                      merchant.find((item) => item.key_cashier === key) || null
                    }
                    onChange={(event, newValue) => {
                      const selectedKey = newValue?.key_cashier || '';
                      setKey(selectedKey);

                      if (newValue) {
                        const methods = ['Cashier', 'QR', 'QRCS'].filter(
                          (method) => newValue.paymentMethod[method],
                        );
                        setPaymentMethod(methods);
                      } else {
                        setPaymentMethod([]);
                      }

                      if (keyError && selectedKey.trim() !== '') {
                        setKeyError(false);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label=""
                        required
                        disabled
                        error={keyError}
                        placeholder={
                          language === 'TH'
                            ? 'บริจาคเพื่อช่วยเหลือพนักงาน'
                            : 'Order ID*'
                        }
                        helperText={
                          keyError
                            ? language === 'TH'
                              ? 'กรุณาเลือกร้านค้า'
                              : 'Order ID is required'
                            : ''
                        }
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              <InputAdornment position="start">
                                <StorefrontIcon />
                              </InputAdornment>
                              {params.InputProps.startAdornment}
                            </>
                          ),
                          sx: {
                            // บังคับสีข้อความเมื่อ disabled
                            '&.Mui-disabled': {
                              color: '#000000 !important',
                              WebkitTextFillColor: '#000000 !important',
                              opacity: 1,
                            },
                            // บังคับสี placeholder
                            '& .MuiInputBase-input.Mui-disabled::placeholder': {
                              color: '#000000 !important',
                              opacity: 1,
                            },
                          },
                        }}
                      />
                    )}
                  />
                </FormControl>
              </Grid>

              {/* <Grid item xs={12}>
                <FormControl fullWidth error={orderIdError}>
                  <TextField
                    required
                    placeholder={
                      language === 'TH' ? 'หมายเลขคำสั่งซื้อ*' : 'Order ID*'
                    }
                    variant="outlined"
                    fullWidth
                    value={orderId}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (input.length <= 20) {
                        setOrderId(input);
                        if (orderIdError && input.trim() !== '') {
                          setOrderIdError(false);
                        }
                      }
                    }}
                    error={orderIdError}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ReceiptIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Box display="flex" justifyContent="space-between">
                    <FormHelperText error={orderIdError}>
                      {orderIdError
                        ? language === 'TH'
                          ? 'กรุณาระบุหมายเลขคำสั่งซื้อ'
                          : 'Order ID is required'
                        : ' '}
                    </FormHelperText>
                    <FormHelperText>{`${orderId.length}/20`}</FormHelperText>
                  </Box>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth error={nameError}>
                  <TextField
                    required
                    placeholder={
                      language === 'TH' ? 'ชื่อลูกค้า*' : 'Customer Name'
                    }
                    variant="outlined"
                    fullWidth
                    value={name}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (input.length <= 100) {
                        setName(input);
                        if (nameError && input.trim() !== '') {
                          setNameError(false);
                        }
                      }
                    }}
                    error={nameError}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PersonIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Box display="flex" justifyContent="space-between">
                    <FormHelperText error={nameError}>
                      {nameError
                        ? language === 'TH'
                          ? 'กรุณาระบุชื่อลูกค้า'
                          : 'Customer Name is required'
                        : ' '}
                    </FormHelperText>
                    <FormHelperText>{`${name.length}/100`}</FormHelperText>
                  </Box>
                </FormControl>
              </Grid> */}
              <Grid item xs={12}>
                <TextField
                  required
                  placeholder={language === 'TH' ? 'จำนวนเงิน*' : 'Amount*'}
                  variant="outlined"
                  fullWidth
                  type="number"
                  value={amount}
                  onChange={(e) => {
                    const input = e.target.value;
                    const regex = /^\d*\.?\d{0,2}$/; // ตัวเลขจำนวนเต็ม หรือทศนิยมไม่เกิน 2 ตำแหน่ง

                    if (input === '' || regex.test(input)) {
                      const num = parseFloat(input);

                      // ถ้าว่าง ให้เคลียร์ค่าได้
                      if (input === '') {
                        setAmount('');
                        setAmountError(true);
                        return;
                      }

                      // เช็คว่าเป็นตัวเลข และอยู่ในช่วงที่อนุญาต
                      if (!isNaN(num)) {
                        if (num >= minAmount && num <= maxAmount) {
                          setAmount(input);
                          setAmountError(false);
                        } else {
                          // ไม่อัพเดทค่าใน state แต่ set error
                          setAmountError(true);
                        }
                      }
                    }
                  }}
                  error={amountError}
                  helperText={
                    amountError
                      ? language === 'TH'
                        ? `กรุณากรอกจำนวนเงิน ${minAmount} - ${maxAmount}`
                        : `Please enter an amount between ${minAmount} - ${maxAmount}`
                      : ''
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CurrencyBitcoinIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ mt: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                    {language === 'TH'
                      ? 'เลือกช่องทางการชำระเงิน'
                      : 'Select Payment Method'}
                  </Typography>

                  <Grid container spacing={2} justifyContent="center">
                    <Grid item xs={6} sm={6}>
                      <Button
                        fullWidth
                        variant="contained"
                        disabled={amount === ''}
                        onClick={() => handleAttemptClick('QR')}
                        sx={{
                          bgcolor: '#1abc9c',
                          color: 'white',
                          height: 100,
                          borderRadius: 4,
                          flexDirection: 'column',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          '&:hover': {
                            bgcolor: '#16a085',
                          },
                        }}
                      >
                        <Box
                          component="img"
                          src={thai_qr_logo}
                          alt="QR Logo"
                          sx={{
                            width: 55,
                            height: 55,
                          }}
                        />
                        <Typography
                          sx={{ fontWeight: 'bold' }}
                          variant="caption"
                        >
                          Thai QR / Promptpay
                        </Typography>
                      </Button>
                    </Grid>

                    {/* <Grid item xs={6} sm={6}>
                      <Button
                        fullWidth
                        variant="contained"
                        disabled={!paymentMethod.includes('QRCS')}
                        onClick={() => handleAttemptClick('QRCS')}
                        sx={{
                          bgcolor: '#2980b9',
                          color: 'white',
                          height: 100,
                          borderRadius: 4,
                          flexDirection: 'column',
                          '&:hover': {
                            bgcolor: '#2471a3',
                          },
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <QrCodeScannerIcon sx={{ fontSize: 30 }} />
                          <Box
                            component="img"
                            src={creditcardLogo}
                            alt="QR Logo"
                            sx={{
                              width: '75%',
                              height: '100%',
                            }}
                          />
                        </Box>
                        <Typography
                          sx={{ fontWeight: 'bold' }}
                          variant="caption"
                        >
                          QR Visa Mastercard
                        </Typography>
                      </Button>
                    </Grid> */}

                    {/* <Grid item xs={6} sm={6}>
                      <Button
                        fullWidth
                        variant="contained"
                        // disabled={!paymentMethod.includes('Cashier')}
                        onClick={() => handleAttemptClick('Cashier')}
                        sx={{
                          bgcolor: '#f39c12',
                          color: 'white',
                          height: 100,
                          borderRadius: 4,
                          flexDirection: 'column',
                          '&:hover': {
                            bgcolor: '#e67e22',
                          },
                        }}
                      >
                        <LinkIcon sx={{ fontSize: 30 }} />
                        <Typography
                          sx={{ fontWeight: 'bold' }}
                          variant="caption"
                        >
                          สร้างลิงก์ชำระเงิน
                        </Typography>
                      </Button>
                    </Grid> */}
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Donation;
